import { EuiButtonIcon, EuiHealth, EuiLink } from "@elastic/eui";
import {
  ActionIcon,
  Anchor,
  Button,
  Divider,
  Flex,
  Grid,
  Group,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import Repository from "../../../_base/helper/HttpHelper";
import { modifyDisableUserComment } from "../../../api/ApiUserComment";
import AppAction from "../../../common/AppAction";
import { API_ROUTE } from "../../../const/apiRoute";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblUserComment } from "../../../model/TblUserComment";
import DeleteView from "./DeleteView";
// import ReplyTable from "./Replytable";
import { useForm } from "@mantine/form";
import {
  IconCategory,
  IconMessage2Plus,
  IconPackage,
  IconSearch,
  IconStatusChange,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_Row,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import { useLocation } from "react-router-dom";
import { styleTableMantine } from "../../../_base/_const/_constVar";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import ModalUpdateExcelProduct from "../../ProductManager/ProductList/ModalUpdate/ModalUpdateExcelProduct";
import FormComent from "./FormComent";
import ReplyComment from "./ReplyComment";

const UserCommentList = () => {
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 60,
      },
      {
        accessorKey: "userName",
        header: "khách hàng",
      },
      {
        id: "actions",
        header: "Thao tác",
        Cell: ({ row }) => {
          const online = row.original;
          return (
            <Group justify="center">
              <Tooltip label="Thêm phản hồi">
                <ActionIcon
                  variant="subtle"
                  onClick={() =>
                    CreateItem({
                      id: online.id,
                      // content: online.content,
                      // itemTitle: online.itemTitle,
                      itemTitle: online.itemTitle,
                    })
                  }
                >
                  <IconMessage2Plus size={20} color="blue" />
                </ActionIcon>
              </Tooltip>
              <Tooltip label="Chỉnh sửa">
                <ActionIcon
                  variant="subtle"
                  onClick={() =>
                    !online
                      ? NotificationExtension.Warn(
                          "Xin vui lòng chọn dữ liệu !"
                        )
                      : EditItem(online)
                  }
                >
                  <EuiButtonIcon iconType="documentEdit" color="success" />
                </ActionIcon>
              </Tooltip>

              <Tooltip label="Xoá">
                <ActionIcon
                  variant="subtle"
                  onClick={() =>
                    !online
                      ? NotificationExtension.Warn(
                          "Xin vui lòng chọn dữ liệu !"
                        )
                      : deleteItem([online.id])
                  }
                >
                  <EuiButtonIcon iconType="trash" color="danger" />
                </ActionIcon>
              </Tooltip>
            </Group>
          );
        },
        size: 130,
        enableColumnActions: false,
        enableSorting: false,
      },
      {
        accessorKey: "userEmail",
        header: "Email khách hàng",
        size: 200,
      },
      {
        accessorKey: "itemTitle",
        header: "Sản phẩm",
        size: 300,
        Cell: ({ cell, row }) => (
          <Anchor
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              wordBreak: "break-word",
              lineHeight: "1.4",
              maxWidth: "280px", // Giới hạn chiều rộng để text xuống dòng
              padding: "4px 0",
            }}
            target="_blank"
            href={`${hacomUrl}/${row.original.itemUrl}`}
            underline="always"
            onClick={(e) => e.stopPropagation()}
          >
            {cell.getValue<string>()}
          </Anchor>
        ),
      },
      {
        accessorKey: "content",
        header: "Nội dung",
        size: 300,
        Cell: ({ renderedCellValue }) => (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              wordBreak: "break-word",
              lineHeight: "1.4",
              maxWidth: "280px", // Giới hạn chiều rộng để text xuống dòng
              padding: "4px 0",
            }}
          >
            {renderedCellValue}
          </div>
        ),
      },
      {
        accessorKey: "creationDate",
        header: "Ngày",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "replyCount",
        header: "Phản hồi",
        Cell: ({ renderedCellValue, row }: any) => (
          <Group gap="xs" justify="center">
            <Text c="red">{renderedCellValue}</Text>
            {renderedCellValue > 0 && (
              <ActionIcon
                variant="subtle"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  row.getToggleExpandedHandler()();
                }}
              >
                <EuiButtonIcon
                  iconType={row.getIsExpanded() ? "arrowUp" : "arrowDown"}
                  color="primary"
                  size="s"
                />
              </ActionIcon>
            )}
          </Group>
        ),
        size: 120,
      },
      {
        accessorKey: "approved",
        header: "Trạng thái",
        Cell: ({ row }) => {
          const { approved, id } = row.original;
          return (
            <EuiLink target="_blank" onClick={() => handleEditDisable(id)}>
              <EuiHealth color={approved === "Y" ? "green" : "danger"}>
                {approved === "Y" ? "Đã duyệt" : "Chưa duyệt"}
              </EuiHealth>
            </EuiLink>
          );
        },
        size: 120,
      },
    ],
    []
  );

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [datas, setDatas] = useState<TblUserComment[]>([]);
  const [total, setTotal] = useState(0);
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [rowCount, setRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectIds, setSelectIds] = useState<any[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  // const handleEditData = async (data: TblUserComment) => {
  //   if (data) {
  //     editItem(data);
  //   } else {
  //     NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
  //   }
  // };
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  type SearchCriteria = {
    keySearch?: string;
    ItemType?: string;
    Approved?: string;
    ItemSearch?: string;
  };
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
      ItemSearch:
        _searchJson && checkedPinSearch ? _searchJson?.ItemSearch : "",
      ItemType: _searchJson && checkedPinSearch ? _searchJson?.ItemType : "",
      Approved: _searchJson && checkedPinSearch ? _searchJson?.Approved : "",
    },
  });
  const handleEditDisable = async (id: number) => {
    await modifyDisableUserComment(id);
    fetchDataUserComment();
  };

  const openModalDelete = () => {
    if (selectIds && selectIds.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      deleteItem(selectIds);
    }
  };
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  function deleteItem(idItem: number[]) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa bình luận</Title>
        </>
      ),
      children: (
        <DeleteView
          onClose={setDeleteViewStatus}
          isEditMode={true}
          idItem={idItem}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }
  type ItemData = {
    id: string;
    // content: string;
    // itemTitle: string;
    itemTitle: string;
  };

  const CreateItem = async (data: ItemData) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Tạo mới</Title>
        </>
      ),
      size: "auto",
      children: (
        <FormComent
          data={data}
          onClose={setDeleteViewStatus}
          isEditMode={false}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  };
  const EditItem = async (data: ItemData) => {
    console.log("data", data);
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa</Title>
        </>
      ),
      size: "auto",
      children: (
        <FormComent
          data={data}
          onClose={setDeleteViewStatus}
          isEditMode={true}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  };

  const MemoizedDeliveryList = React.memo(ReplyComment);

  const DeliveryWrapper = memo(
    ({ tblUserCommentReplyModels }: { tblUserCommentReplyModels: any }) => {
      return (
        <MemoizedDeliveryList
          dataDetail={tblUserCommentReplyModels}
          onClose={setDeleteViewStatus}
        />
      );
    }
  );

  const renderDetailPanel = useCallback(({ row }: { row: MRT_Row<any> }) => {
    if (!row.original) return <></>;
    return (
      <DeliveryWrapper
        key={row.id}
        tblUserCommentReplyModels={row.original.tblUserCommentReplyModels}
      />
    );
  }, []);
  const fetchDataUserComment = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const search = form.getValues();
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    try {
      let urlSearch = `${API_ROUTE.GET_LIST_USER_COMMENT}?Skip=${
        pagination?.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;
      if (search.keySearch) {
        urlSearch += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      if (search.ItemType) {
        urlSearch += `&ItemType=${search.ItemType}`;
      }
      if (search.Approved) {
        urlSearch += `&Approved=${search.Approved}`;
      }
      if (search.ItemSearch) {
        urlSearch += `&ItemSearch=${search.ItemSearch}`;
      }
      let callapi = await repository.get<MessageResponse<any>>(urlSearch);
      if (callapi && callapi.success) {
        setDatas(callapi?.data ?? []);
        setRowCount(callapi?.totalCount ?? 0);
        setTotal(callapi?.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setDatas([]);
        setRowCount(0);
        setIsLoading(false);
      }
      return callapi?.data;
    } catch (error: any) {
      setDatas([]);
      setIsError(true);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(form.getValues())
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDataUserComment();
    };
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, deleteViewStatus]);

  const table = useMantineReactTable({
    columns,
    data: datas,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    renderDetailPanel: renderDetailPanel,
    enableExpanding: false,
    getRowCanExpand: (row) => row.original.replyCount > 0,
    positionExpandColumn: "last",
    displayColumnDefOptions: {
      "mrt-row-expand": {
        size: 0,
        Cell: () => null,
      },
    },

    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "userName"],
        right: ["mrt-row-expand", "actions"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  // hàm mở modal để cập nhật file excel
  const openModalupdateExel = () => {
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>
              Tạo comment khách hàng cho sản phẩm bằng Excel
            </Title>
          </div>
        </>
      ),
      children: <ModalUpdateExcelProduct location={location} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  return (
    <>
      {/* <AppAction
        openModalDelete={openModalDelete}
        openModalEdit={openModalEdit}
      ></AppAction> */}
      <Flex
        gap="md"
        justify={"space-between"}
        align="center"
        direction="row"
        wrap="wrap"
        w={"100%"}
      >
        <BreadCrumb></BreadCrumb>
        <AppAction
          // openModal={openModal}
          // openModalDelete={openModalDelete}
          // openModalEdit={openModalEdit}
          openModalupdateExel={openModalupdateExel}
        ></AppAction>
      </Flex>

      <Divider my="sm" />
      {/* <AppSearch
        loading={loading}
        onChange={onChange}
        onChangeText={onChangeText}
        onSearch={() => fetchDataUserComment()}
        elementSearch={elementSearch}
      /> */}
      {/* <EuiSpacer size="l" /> */}
      {/* <EuiBasicTable
        tableCaption="Demo of EuiDataGrid with selection"
        items={datas ? datas : []}
        itemId="id"
        error={error}
        loading={loading}
        noItemsMessage={"Không có dữ liệu"}
        selection={selection}
        columns={columns}
        pagination={pagination}
        isSelectable={true}
        hasActions={true}
        responsive={true}
        onChange={onTableChange}
        compressed={true}
      /> */}
      <Grid justify="space-between" align="center" mb={10}>
        <Grid.Col span="auto">
          <Group gap="sm">
            <TextInput
              placeholder="Nhập tìm kiếm"
              key={form.key("keySearch")}
              leftSection={<IconSearch size={20} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchDataUserComment();
                }
              }}
              {...form.getInputProps("keySearch")}
              w={200}
            />
            <TextInput
              placeholder="Nhập tên sản phẩm\SKU"
              key={form.key("ItemSearch")}
              leftSection={<IconPackage size={20} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchDataUserComment();
                }
              }}
              {...form.getInputProps("ItemSearch")}
              w={200}
            />
            <Select
              placeholder="Thể loại"
              key={form.key("ItemType")}
              leftSection={<IconCategory size={20} color="#15aabf" />}
              data={[
                { value: "article", label: "Bài viết" },
                { value: "product", label: "Sản phẩm" },
              ]}
              clearable
              {...form.getInputProps("ItemType")}
              w={200}
            />
            <Select
              placeholder="Trạng thái"
              key={form.key("Approved")}
              leftSection={<IconStatusChange size={20} color="#15aabf" />}
              data={[
                { value: "N", label: "Chưa duyệt" },
                { value: "Y", label: "Đã duyệt" },
              ]}
              clearable
              {...form.getInputProps("Approved")}
              w={200}
            />
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchDataUserComment();
              }}
            >
              Tìm kiếm
            </Button>
          </Group>
        </Grid.Col>

        <Grid.Col span="content">
          <Group justify="flex-end">
            <AppAction openModalDelete={openModalDelete}></AppAction>
          </Group>
        </Grid.Col>
      </Grid>
      <MantineReactTable table={table} />
    </>
  );
};

export default UserCommentList;
